import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';

function NavbarComponent() {
  const [showServices, setShowServices] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    const handleResize = () => setIsMobile(window.innerWidth < 992);

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleNavItemClick = () => {
    setExpanded(false);
    setShowServices(false);
  };

  const toggleServicesDropdown = () => {
    setShowServices(prev => !prev);
  };

  return (
    <Navbar
      expand="lg"
      fixed="top"
      expanded={expanded}
      onToggle={setExpanded}
      className={`premium-navbar shadow-sm py-2 ${scrolled ? 'scrolled' : ''}`}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex align-items-center gap-2">
          <img
            src="/images/AV Logo (2).png"
            alt="AV Logo"
            // width="120"
            // height="50"
            className=" navbar-logo d-inline-block align-top"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto align-items-center gap-lg-4 gap-3">
            <Nav.Link as={Link} to="/" className="nav-link-premium" onClick={handleNavItemClick}>
              <i className="fas fa-home me-1"></i> Home
            </Nav.Link>

            {/* <NavDropdown
              title={
                <span className={`services-title ${scrolled ? 'text-dark' : 'text-white'}`}>
                  <i className="fas fa-cogs me-1"></i> Services <span>{showServices ? '▲' : '▼'}</span>
                </span>
              }
              id="services-dropdown"
              className="nav-link-premium custom-dropdown no-arrow"
              show={showServices}
              onMouseEnter={() => !isMobile && setShowServices(true)}
              onMouseLeave={() => !isMobile && setShowServices(false)}
              onClick={toggleServicesDropdown}
            >
              <div className="dropdown-grid-3x2 px-2 py-2">
                <NavDropdown.Item as={Link} to="/services/NetworkDesign" onClick={handleNavItemClick}>
                  Network Design Services &nbsp; →
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/TelecomSupport" onClick={handleNavItemClick}>
                  Telecom Support Services &nbsp; →
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/DataCenter" onClick={handleNavItemClick}>
                  Data Center Solutions &nbsp; →
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/WebAndApp" onClick={handleNavItemClick}>
                  Web & App Development &nbsp; →
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/desktop-support" onClick={handleNavItemClick}>
                  Desktop Support &nbsp; →
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/ManagedServices" onClick={handleNavItemClick}>
                  Managed Services &nbsp; →
                </NavDropdown.Item>
              </div>
            </NavDropdown> */}



            <Nav.Link as={Link} to="/about" className="nav-link-premium" onClick={handleNavItemClick}>
              <i className="fas fa-users me-1"></i> About Us
            </Nav.Link>
                 <NavDropdown
  title={
    <span className="services-title">
      <i className="fas fa-cogs me-1"></i> Services <span className="arrow-symbol">{showServices ? '▲' : '▼'}</span>
    </span>
  }
  id="services-dropdown"
  className="nav-link-premium custom-dropdown"
  show={showServices}
  onMouseEnter={() => !isMobile && setShowServices(true)}
  onMouseLeave={() => !isMobile && setShowServices(false)}
  onClick={() => isMobile && toggleServicesDropdown()}
>
  <div className="dropdown-grid-2col px-2 py-2">
    <NavDropdown.Item as={Link} to="/services/NetworkDesign" onClick={handleNavItemClick}>
      Network Design Services
    </NavDropdown.Item>
    <NavDropdown.Item as={Link} to="/services/TelecomSupport" onClick={handleNavItemClick}>
      Telecom Support Services
    </NavDropdown.Item>
    <NavDropdown.Item as={Link} to="/services/DataCenter" onClick={handleNavItemClick}>
      Data Center Solutions
    </NavDropdown.Item>
    <NavDropdown.Item as={Link} to="/services/WebAndApp" onClick={handleNavItemClick}>
      Web & App Development
    </NavDropdown.Item>
    <NavDropdown.Item as={Link} to="/services/desktop-support" onClick={handleNavItemClick}>
      Desktop Support
    </NavDropdown.Item>
    <NavDropdown.Item as={Link} to="/services/ManagedServices" onClick={handleNavItemClick}>
      Managed Services
    </NavDropdown.Item>
     <NavDropdown.Item as={Link} to="/services/cybersecurity" onClick={handleNavItemClick}>
      Cybersecurity Solutions
    </NavDropdown.Item>
     <NavDropdown.Item as={Link} to="/services/HardwareSupport" onClick={handleNavItemClick}>
     End Of life Hardware Support & Supply
    </NavDropdown.Item>
  </div>
</NavDropdown>


            <Nav.Link as={Link} to="/contact" className="nav-link-premium" onClick={handleNavItemClick}>
              <i className="fas fa-envelope me-1"></i> Contact Us
            </Nav.Link>

            <Nav.Link
              href="https://alignedvertical.com/webmail/?_task=mail&_mbox=INBOX"
              target="_blank"
              rel="noopener noreferrer"
              className="employee-login-btn"
            >
              <i className="fas fa-sign-in-alt me-1"></i> Employee Login
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarComponent;